import React from 'react'
import styled from 'styled-components'
import {
  Modal as AntModal,
  ModalFooter,
} from 'reactstrap'
import { IoIosCloseCircle, IoIosAddCircleOutline } from 'react-icons/io'
import { AiOutlineSave } from 'react-icons/ai'
import some from 'lodash/some'

import { BillingDetail } from './billing-detail'
import { ListDetail } from './list-detail'
import { Button } from '../../../../buttons'
import { CustomSearchSelect } from '../../../../input'
import { FONTS } from '../../../../../constants'
import { toNumber } from '../../../../../function/math'
import { piStatusOptions, statusOptions } from '../constants'

export const CreateBilling = ({
  isCreate,
  // index,
  data,
  handleClose,
  createDetail,
  editingBillings,
  updateEditingBillings,
  revenueAllocation,
  billings,
  interpretBillingType,
  projectRevenue,
  projectAvailable,
}) => {
  const rowWrapper = document.getElementById('rowWrapperCreateBilling')
  const _editingBillings = [...editingBillings]

  const _status = statusOptions.find(s => s.value === data.status)

  const canSave = data.name !== ''
  && data.invoice_date
  && !some(data.billing_types, { type: '' })
  && !some(data.billing_types, d => +d.price === 0)
  && toNumber(projectAvailable) >= 0

  const handleInput = (e, name) => {
    const { billing_no } = data
    const _data = { ...data }
    _data[name] = e
    const index = _editingBillings.findIndex(b => b.billing_no === billing_no)
    _editingBillings[index] = _data
    updateEditingBillings(_editingBillings)
  }

  const handleListsDetails = (e, name, idx) => {
    const { billing_no } = data
    const _data = { ...data }
    const billing_types = [..._data.billing_types]
    const billing = { ...billing_types[idx] }
    if (name === 'type') {
      billing.type = e.value
      billing.label = e.label
      billing.cr_id = e.cr_id
      billing.product_id = e.product_id
    } else {
      billing[name] = e
    }
    billing_types[idx] = billing
    _data.billing_types = billing_types
    const index = _editingBillings.findIndex(b => b.billing_no === billing_no)
    _editingBillings[index] = _data
    updateEditingBillings(_editingBillings)
  }

  const handleAddDetail = () => {
    const { billing_no } = data
    const _data = {
      ...data,
      billing_types: [
        ...data.billing_types,
        { type: '', price: '0', label: '', cr_id: '', product_id: '' },
      ],
    }
    const index = _editingBillings.findIndex(b => b.billing_no === billing_no)
    _editingBillings[index] = _data
    updateEditingBillings(_editingBillings)
    if (rowWrapper) rowWrapper.scrollTop = rowWrapper.scrollHeight - rowWrapper.clientHeight
  }

  const handleRemoveDetail = idx => {
    const { billing_no } = data
    const _data = { ...data }
    const billing_types = [...data.billing_types]
    billing_types.splice(idx, 1)
    _data.billing_types = billing_types
    const index = _editingBillings.findIndex(b => b.billing_no === billing_no)
    _editingBillings[index] = _data
    updateEditingBillings(_editingBillings)
  }

  const resetState = () => {
    _editingBillings.splice(_editingBillings.length - 1, 1)
    updateEditingBillings(_editingBillings)
  }

  const closeModal = () => {
    resetState()
    handleClose()
  }

  return (
    <Modal
      size='lg'
      isOpen={ isCreate }
      toggle={ closeModal }
    >
      <ModalHeader toggle={ closeModal }>
        <HeaderText>Create Billing Milestone</HeaderText>
        <AlignCenterWrapper>
          <StatusText>Status</StatusText>
          <DrodownWrapper>
            <CustomSearchSelect
              placeholder='Select Status'
              options={ piStatusOptions }
              value={ _status }
              onChange={ e => handleInput(e.value, 'status') }
            />
          </DrodownWrapper>
          <IoIosCloseCircle onClick={ closeModal } />
        </AlignCenterWrapper>
      </ModalHeader>

      <BodyWrapper id='rowWrapperCreateBilling'>
        <BillingDetail
          detailState={ data }
          handleInput={ handleInput }
          projectRevenue={ projectRevenue }
          projectAvailable={ projectAvailable }
        />
        <ListDetail
          detailState={ data }
          handleListsDetails={ handleListsDetails }
          handleRemoveDetail={ handleRemoveDetail }
          revenueAllocation={ revenueAllocation }
          billings={ billings }
          interpretBillingType={ interpretBillingType }
        />
      </BodyWrapper>

      <AddWrapper onClick={ handleAddDetail }>
        <IoIosAddCircleOutline style={ { color: '#2D9CDB', fontSize: 16 } } />
        <AddText>&nbsp;Add Detail</AddText>
      </AddWrapper>
      <ModalFooter>
        <ButtonWrapper>
          <ButtonGroup>
            <Button
              theme='#28a745'
              icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
              width='70px'
              height='26px'
              disabled={ !canSave }
              onClick={ createDetail }
            >
                Save
            </Button>
            <Button
              theme='#6c757d'
              width='70px'
              height='26px'
              onClick={ closeModal }
            >
                Cancel
            </Button>
          </ButtonGroup>
        </ButtonWrapper>
      </ModalFooter>
    </Modal>
  )
}

const Modal = styled(AntModal)`
  .modal-header {
    border: none;
  }

  .modal-footer {
    border: none;
    background: #F9F9F9;
  }
`

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px 0 16px;

  svg {
      font-size: 24px;
      color: #C4C4C4;
      cursor: pointer;
  }
`

const DrodownWrapper = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  margin: 0 16px;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 500px;
  max-height: 500px;
  overflow-y: scroll;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 28px 16px 0 16px;
`

const Row = styled.div`
  display: flex;
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;

  div:nth-child(1) {
    margin-right: 12px;
  }
`

const ButtonWrapper = styled(Row)`
  justify-content: flex-end;
  flex: 1;
`

const AddWrapper = styled(Row)`
  height: 30px;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
`

const AddText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #2D9CDB;
`

const AlignCenterWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`

const StatusText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/create-billing/index.js